module.exports = __webpack_public_path__ + "media/frontend/components/lobby/bg-header-cd2fd059270ca661f35290051061b78b.png";